// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eV9s","field":"styles_field__1SpJf","fieldCol":"styles_fieldCol__plROK","diffCol":"styles_diffCol__3EsY7","diff":"styles_diff__1rfQU"};